// extracted by mini-css-extract-plugin
export default {"wrapper":"Tabs_wrapper__qb88B","headersWrapper":"Tabs_headersWrapper__fHPdq","headers":"Tabs_headers__uwQ6s","header":"Tabs_header__GRHtX","tabActive":"Tabs_tabActive__GVyna"};